mutation EnableOrganizationUser($id: ID!) {
  enableOrganizationUser(id: $id) {
    id
    disabled
  }
}
